import { render, staticRenderFns } from "./PriceSettingsGuide.vue?vue&type=template&id=cb47bb26&scoped=true"
import script from "./PriceSettingsGuide.vue?vue&type=script&lang=js"
export * from "./PriceSettingsGuide.vue?vue&type=script&lang=js"
import style0 from "./PriceSettingsGuide.vue?vue&type=style&index=0&id=cb47bb26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb47bb26",
  null
  
)

export default component.exports